module.exports = __webpack_public_path__ + "img/voice-thumb1.978d5d4.jpg";